import React, { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import Select from 'pages/reference-implementation/components/select';
import { RIStyles } from 'pages/reference-implementation/Style';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';

const Redis = (props) => {
    const { resource, handleDrawerAction } = props;

    const [formData, setFormData] = useState({
        redisType: resource?.configureData?.redisType || null,
    });

    const [redisTypeOptions, setRedisTypeOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    const redisDeploymentTypesApi = useMutation(() => axios.get(endPoints.aws.lookups.redisDeploymentTypes));

    useEffect(() => {
        redisDeploymentTypesApi.mutate();
    }, []);

    useEffect(() => {
        if (redisDeploymentTypesApi?.isSuccess && redisDeploymentTypesApi?.data?.data?.length) {
            const options = redisDeploymentTypesApi?.data?.data?.map((item) => ({
                label: item,
                value: item,
            }));
            setRedisTypeOptions(options);
        }
    }, [redisDeploymentTypesApi?.isSuccess]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.redisType) {
            newErrors.redisType = { type: 'required', message: 'Redis Type is required' };
        }
        setErrors(newErrors);
        return { isValid: Object.keys(newErrors).length === 0, errors: newErrors };
    };

    const handleOnSelectChange = (key, value) => {
        setFormData({ ...formData, [key]: value });
        setTouched({ ...touched, [key]: true });
    };

    const handleSubmit = () => {
        setTouched({ redisType: true });
        const checkFormValid = validateForm();
        handleDrawerAction('save', formData, checkFormValid);
    };

    const shouldShowError = (field) => touched[field] && !!errors[field];

    useEffect(() => {
        if (Object.keys(touched).length > 0) {
            validateForm();
        }
    }, [formData]);

    return (
        <Box style={RIStyles.tags.wrapper} className="ri-layout">
            <Box sx={RIStyles.tags.contentWrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <Select
                                key="redisType"
                                label="Deployment Type *"
                                value={formData?.redisType || null}
                                options={redisTypeOptions}
                                handleOnSelect={(value) => handleOnSelectChange('redisType', value?.value)}
                                isRequired={shouldShowError('redisType')}
                                isLoading={redisDeploymentTypesApi?.isLoading}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box className="footer" sx={RIStyles.tags.actionWrapper} gap={2}>
                <Btn className="custom-btn" variant="contained" sx={style.modalSaveButton} onClick={() => handleSubmit()} data-testid="save-btn">
                    Save
                </Btn>
                <Btn
                    className="custom-btn"
                    variant="outlined"
                    sx={style.modalCancelButton}
                    onClick={() => handleDrawerAction('cancel')}
                    data-testid="cancel-btn"
                >
                    Cancel
                </Btn>
            </Box>
        </Box>
    );
};

Redis.propTypes = {
    resource: PropTypes.any.isRequired,
    handleDrawerAction: PropTypes.func.isRequired,
};

export default Redis;
